import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { COLUMN_DATA_TYPE, COLUMN_SORT_DIRECTION } from './emma-table.helpers';

@Component({
    selector: 'emma-table-column-sort-icon',
    templateUrl: './emma-table-column-sort-icon.component.html',
    standalone: false
})
export class EMMATableColumnSortIconComponent implements OnChanges {
  @Input() direction: COLUMN_SORT_DIRECTION = COLUMN_SORT_DIRECTION.NONE;
  @Input() type?: COLUMN_DATA_TYPE;
  directionIcon = '';

  DATA_TYPE = COLUMN_DATA_TYPE;

  ngOnChanges(changes: SimpleChanges): void {
    if ('direction' in changes) {
      switch (this.direction) {
        case COLUMN_SORT_DIRECTION.ASC:
          this.directionIcon = 'asc';
          break;
        case COLUMN_SORT_DIRECTION.DESC:
          this.directionIcon = 'desc';
          break;
        default:
          this.directionIcon = '';
      }
    }
  }
}
